<template>
  <div id="app">
    <div class="row" v-show="!show">
      <div class="col-lg-8 col-md-8 offset-md-2 mb-4" v-if="profile.coins">
        <h5>
          <strong
            >Your Wallet Amount:
            <span v-if="profile.main_balance && profile.main_balance.length > 0"
              >{{ profile.main_balance[0].balance.toFixed(3) }}
              US$</span
            ><span v-else>n/a</span></strong
          >
        </h5>
      </div>
      <div class="col-lg-8 col-md-8 offset-md-2">
        <b-form @submit.prevent>
          <b-form-group label-for="pay-email">
            <span class="text-danger pr-1">*</span>
            <span for="pay-email">Enter the email address</span>
            <b-form-input
              id="pay-email"
              type="email"
              v-model="email"
              placeholder="Email Address"
              class="my-3 w-100"
            ></b-form-input>
            <span class="text-danger float-right" v-if="errors.email">{{
              errors.email
            }}</span>
          </b-form-group>

          <b-form-group label-for="amount">
            <span class="text-danger pr-1">*</span>
            <span for="amount">Enter the amount in Dollar</span>
            <b-form-input
              id="amount"
              type="text"
              min="1"
              step="0.001"
              v-model="amount"
              onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46"
              placeholder="Amount in Dollar"
              class="my-3 w-100"
            ></b-form-input>
            <span class="text-danger float-right" v-if="errors.amount">{{
              errors.amount
            }}</span>
          </b-form-group>

          <b-form-group label-for="remarks">
            <span class="text-danger pr-1">*</span>
            <label for="remarks">Remarks</label>
            <b-form-textarea
              placeholder="Remarks"
              id="remarks"
              v-model="remarks"
              rows="5"
              class="my-3"
            ></b-form-textarea>
            <span class="text-danger float-right" v-if="errors.remarks">{{
              errors.remarks
            }}</span>
          </b-form-group>

          <b-button
            type="submit"
            variant="amej-button"
            :class="{ available: available }"
            @click="handlePayForm"
            >Continue</b-button
          >
        </b-form>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-8 col-md-8 offset-md-2">
        <transition name="fade">
          <div v-show="show">
            <b-form @submit.prevent>
              <b-form-group label-for="otp">
                <label>
                  <span class="text-danger pr-1">*</span>Enter your TRANSACTION
                  PIN number to verify the process.</label
                >
                <b-form-input
                  id="otp"
                  type="text"
                  v-model="otp"
                  maxlength="4"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  placeholder="Transaction PIN Number"
                ></b-form-input>
                <span class="text-danger float-right" v-if="errors.otp">{{
                  errors.otp
                }}</span>
              </b-form-group>

              <div class="col-md-12 text-center">
                <b-button
                  type="submit"
                  variant="amej-button"
                  @click="CompleteTransaction"
                  >Complete Transaction</b-button
                >
              </div>
            </b-form>
          </div>
        </transition>
      </div>
    </div>

    <b-modal
      ref="loader_modal"
      id="loader_modal"
      class="loader_modal"
      size="sm"
      text-center
      headerClass="border-bottom-0"
      centered
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <div class="text-center p-4">
        <b-spinner variant="light" label="Text Centered"></b-spinner>
      </div>
    </b-modal>

    <b-toast
      id="success-toast"
      variant="success"
      solid
      append-toast
      toaster="b-toaster-top-center"
    >
      <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
        <strong class="mr-auto">Success!!!</strong>
      </div>
      <!-- <div class="text-danger" v-for="(error,index) in errors.auth" :key="index">{{ error }}</div> -->
      <p>Transaction Successful</p>
    </b-toast>

    <b-toast
      id="error-toast"
      variant="danger"
      solid
      append-toast
      toaster="b-toaster-top-center"
    >
      <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
        <strong class="mr-auto">Error!!!</strong>
      </div>
      <!-- <div class="text-danger" v-for="(error,index) in errors.auth" :key="index">{{ error }}</div> -->
      <div v-if="message || otpmessage || fundtransactionerror">
        <p v-if="message.length > 0">{{ message }}</p>
        <p v-if="otpmessage.length > 0">{{ otpmessage }}</p>
        <p v-if="fundtransactionerror && fundtransactionerror.length > 0">
          {{ fundtransactionerror }}
        </p>
      </div>
      <!--  <div v-else-if="otpmessage">
        <p v-if="otpmessage.length>0">{{otpmessage}}</p>
      </div>-->
    </b-toast>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
export default {
  name: "FundTransactionForm",
  components: {},

  computed: {
    ...mapState([
      "message",
      "successmessage",
      "otpsuccess",
      "otperror",
      "errormessage",
      "actionurl",
      "profile",
      "otpmessage",
    ]),
  },

  props: ["actionUrl"],
  data() {
    return {
      amount: "",
      email: "",
      remarks: "",
      otp: "",
      errors: [],
      fundtransactionerror: null,
      available: false,
      show: false,
      dismissSecs: 2,
      dismissCountDown1: 0,
      showDismissibleAlert: false,
      showDismissibleAlert1: false,
      countDownChanged: 0,
      transaction_id: "",
      useramount: 0,
    };
  },

  created() {
    this.listProfile();
  },

  mounted: function () {
    if (this.$store.state.token == "") {
      this.$router.replace("/");
    }
  },
  methods: {
    ...mapActions(["listProfile"]),
    handlePayForm() {
      this.errors = [];
      if (this.email == "") {
        this.errors["email"] = "Email required.";
      } else if (this.amount == "") {
        this.errors["amount"] = "Amount required.";
      } else if (this.amount <= 0) {
        this.errors["amount"] = "Amount must be greater than 0.";
      } else if (this.remarks == "") {
        this.errors["remarks"] = "Remarks required.";
      } else {
        this.$refs["loader_modal"].show();
        let sendObj = {
          amount: this.amount,
          to: this.email,
          remarks: this.remarks,
        };

        axios.defaults.headers.common["authorization"] =
          "JWT " + localStorage.getItem("token");
        axios
          .post(this.actionUrl, sendObj)
          .then((response) => {
            if (response.status == 200) {
              this.transaction_id = response.data.transaction;
              this.useramount = response.data.amount;
              this.$refs["loader_modal"].hide();
              (this.show = !this.show), (this.available = !this.available);
            } else {
              this.dismissCountDown1 = this.dismissSecs;
              this.$bvToast.show("error-toast");
              this.$refs["loader_modal"].hide();
              this.$router.replace({ name: "pay" });
            }
          })
          .catch((error) => {
            if (error) {
              this.$bvToast.show("error-toast");
              this.fundtransactionerror = error.response.data.message;
              this.$refs["loader_modal"].hide();
            }
          });

        this.amount = "";
        this.email = "";
        this.remarks = "";
      }
    },
    CompleteTransaction() {
      this.errors = [];
      if (this.otp == "") {
        this.errors["otp"] = "Transaction PIN required.";
      } else if (this.otp.length != 4) {
        this.errors["otp"] = "Transaction PIN must have 4 digits.";
      } else {
        this.$refs["loader_modal"].show();
        let mpinData = {
          transaction_id: this.transaction_id,
          transaction_PIN: this.otp,
          action_url: this.actionUrl,
          amount: this.useramount,
        };
        console.log("MPIND: ", mpinData);
        this.$store.dispatch("transactionOTP", mpinData).then(() => {
          this.$refs["loader_modal"].hide();
          if (this.otpsuccess == "success") {
            this.show = false;
            this.available = false;
            this.$bvToast.show("success-toast");
            setTimeout(() => {
              this.$router.replace({
                name: "app",
              });
            }, 1500);
          }
          if (this.otperror == "otperror") {
            this.$bvToast.show("error-toast");
          }
        });
        this.otp = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 1s !important;
}

.fade-enter,
.fade-leave-to {
  opacity: 0 !important;
  transform: translateY(30px) !important;
}
</style>
